import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

@Component({
  selector: 'page-links',
  templateUrl: 'links.html',
})
export class LinksPage {

  items: any;
  error: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http
  ) {

    let loadingPopup = this.loadingCtrl.create({
      content: ''
    });

    loadingPopup.present();
    console.log(this.params.apiURL + '?act=links');
    this.http.get(this.params.apiURL + '?act=links')
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
          setTimeout(() => {
            console.log(data);
            this.items = data;
            this.error = "0";

            console.log('ITEMS: ' + this.items.id);

            loadingPopup.dismiss();

          }, 1000);

        },

        err => {
          loadingPopup.dismiss();
          this.error = "1";
        }

      );

  }

  OpenLink(url) {
    window.open(url, '_system');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LinksPage');
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/links/links.ts